import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {usePageURLContext} from "../../../contexts/pageURLContext";
import {
  getEventRulesList,
  getEventRulesTotalCount,
  getEventRulesPaginationUrls,
} from "../../../redux/Selectors/eventRule.selector";
import {requestEventRules} from "../../../redux/Actions/eventRule.actions";

export const useFetchEventRules = () => {
  const {pageUrl} = usePageURLContext();
  const dispatch = useDispatch();

  const freshFetch = () => {
    dispatch(requestEventRules());
  };

  const refetch = () => {
    dispatch(requestEventRules(pageUrl));
  };

  return {refetch, freshFetch};
};

export const useEventRulesTableData = () => {
  const dispatch = useDispatch();
  const {refetch, freshFetch} = useFetchEventRules();
  const {setPageUrl} = usePageURLContext();
  const [currentPage, setCurrentPage] = useState(1);
  const eventRuleList = useSelector(getEventRulesList);
  const eventRuleTotalCount = useSelector(getEventRulesTotalCount);
  const eventRuleUrls = useSelector(getEventRulesPaginationUrls);

  useEffect(() => {
    freshFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAfterDelete = () => {
    if (eventRuleList.length === 1) {
      setCurrentPage(1);
      setPageUrl("");
      freshFetch();
    } else {
      refetch();
    }
  };

  const handlePageChange = (page) => {
    const url = currentPage < page ? eventRuleUrls?.nextUrl : eventRuleUrls?.prevUrl;
    dispatch(requestEventRules(url));
    setCurrentPage(page);
    setPageUrl(url);
  };

  const paginationConfig = {currentPage, onPageChange: handlePageChange};

  return {fetchAfterDelete, paginationConfig, eventRuleList, eventRuleTotalCount};
};
